import { Share2, User, BarChart3 } from "lucide-react";
import "./problem.css";
import employmentGirl from "../../../assets/employment-girl.webp";

const problems = [
  {
    icon: Share2,
    title: "Disconnected tools.",
    body: "Resumes, interviews, networking, and applications each live somewhere different, and nothing connects them.",
  },
  {
    icon: User,
    title: "High stress. Little margin for error.",
    body: "Students make consequential decisions without enough information or guidance.",
  },
  {
    icon: BarChart3,
    title: "Career centers can’t scale.",
    body: "Advisors don’t have the data or the capacity to give every student personalized guidance.",
  },
];

const Problem = () => (
  <section className="home-problem" id="problem">
    <div className="home-container home-problem-grid">
      <div className="home-problem-copy">
        <p className="home-eyebrow">The Problem</p>

        <h2 className="home-problem-title">
          <span className="home-problem-em">
            The path from education to employment
          </span>{" "}
          <span className="home-problem-muted">is broken</span>
        </h2>

        <ul className="home-problem-list">
          {problems.map(({ icon: Icon, title, body }) => (
            <li key={title}>
              <span className="home-problem-icon">
                <Icon size={22} strokeWidth={1.75} />
              </span>
              <span className="home-problem-text">
                <strong>{title}</strong>
                <span>{body}</span>
              </span>
            </li>
          ))}
        </ul>
      </div>

      <div className="home-problem-photo">
        <img width={1238} height={1102} decoding="async"
          src={employmentGirl}
          alt="A graduate looking out from campus toward a city skyline"
          loading="lazy"
        />
      </div>
    </div>
  </section>
);

export default Problem;
